import { Lock } from "lucide-react";
import { useNavigate } from "react-router-dom";

// Centralized locked-feature state so every gated screen looks and behaves the
// same way (see back/constants/planEntitlements.js for the source of truth on
// which plan unlocks which feature).
export default function UpgradePrompt({ title, message, className = "" }) {
  const navigate = useNavigate();

  return (
    <div className={`flex flex-col items-center justify-center gap-3 rounded-2xl border border-dashed border-gray-200 bg-white p-10 text-center ${className}`}>
      <div className="flex h-12 w-12 items-center justify-center rounded-full bg-gray-100 text-gray-400">
        <Lock size={22} aria-hidden="true" />
      </div>
      {title && <h3 className="font-bold text-gray-800">{title}</h3>}
      <p className="max-w-sm text-sm text-gray-500">{message || "این قابلیت در بسته فعلی شما فعال نیست."}</p>
      <button
        type="button"
        onClick={() => navigate("/dashboard/pricing")}
        className="mt-1 rounded-lg bg-secondary px-4 py-2 text-sm font-semibold text-white hover:opacity-90"
      >
        مشاهده بسته‌ها
      </button>
    </div>
  );
}
